var styles = {"screenReaderText":"VDS__MON__screen-reader-text-module__g5OOP"};

export { styles as default };
